import styled from "styled-components";

export const DatePeriodPickerContainer = styled.div`
  display: flex;
  width: 20rem;
  align-items: center;
`;
